const SuggestionStatus = Object.freeze({
  New: 1,
  Favorite: 2,
  Archived: 3,
});

export default SuggestionStatus;
